/**
 * ChildAware Website
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type DomainFeedbackStatus = 'Submitted' | 'InProgress' | 'Resolved' | 'Withdrawn';

export const DomainFeedbackStatus = {
    Submitted: 'Submitted' as DomainFeedbackStatus,
    InProgress: 'InProgress' as DomainFeedbackStatus,
    Resolved: 'Resolved' as DomainFeedbackStatus,
    Withdrawn: 'Withdrawn' as DomainFeedbackStatus
};